import { render, staticRenderFns } from "./b-ticket-extras.vue?vue&type=template&id=b127fb36&scoped=true"
import script from "./b-ticket-extras.vue?vue&type=script&lang=ts"
export * from "./b-ticket-extras.vue?vue&type=script&lang=ts"
import style0 from "./b-ticket-extras.vue?vue&type=style&index=0&id=b127fb36&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b127fb36",
  null
  
)

export default component.exports